import { Component, OnInit, Input, ViewChildren, Renderer2, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ThemeService } from '../../services/theme.service';
import { LayoutService } from '../../services/layout.service';
import { MatxNotifications2Component } from '../matx-notifications2/matx-notifications2.component';
import { AppAuthService } from '../../../../core/auth/app-auth.service';
import { IAppUserNotificationsService } from '../app-user-notifications/app-user-notifications.service';
import { APP_USER_NOTIFICATIONS_SERVICE_TOKEN } from '../app-user-notifications/app-user-notifications-config';
import { AccessRightsService } from '../../../../core/access-rights/access-right.service';
import { ActionPermission } from '../../../../core/access-rights/actions';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { AppSearchComponent } from '../app-search/app-search.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-header-side',
  templateUrl: './header-side.template.html',
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatMenuModule,
    RouterModule,
    AppSearchComponent
  ]
})
export class HeaderSideComponent implements OnInit {
  @Input() notificPanel: any;
  @ViewChildren(MatxNotifications2Component) noti: any;

  public initials: string = '';
  public username: string = '';
  public matxThemes: any;
  public layoutConf: any;
  public showNotifications: boolean = false;

  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    private renderer: Renderer2,
    private _authService: AppAuthService,
    private _accessRightsService: AccessRightsService,
    @Inject(APP_USER_NOTIFICATIONS_SERVICE_TOKEN) public notificationsService: IAppUserNotificationsService
  ) { }

  ngOnInit() {
    this.matxThemes = this.themeService.matxThemes;
    this.layoutConf = this.layout.layoutConf;
    //this.translate.use(this.currentLang.code);

    this._authService.getUsername().subscribe(r => {
      this.username = r;

      // Load notifications when user is authenticated
      this.notificationsService.loadNotifications().subscribe({
        error: (err) => {
          console.error('Failed to load notifications:', err);
        }
      });
    });

    // For now the notifications contains only announcements, if user can create announcements then hide notifications
    this.showNotifications = !this._accessRightsService.hasAccessTo(ActionPermission.createAnnouncements);
  }

  changeTheme(theme: any) {
    // this.themeService.changeTheme(theme);
  }
  toggleNotific() {
    this.notificPanel.toggle();
  }
  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full'
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed'
    });
  }

  toggleCollapse() {
    // compact --> full
    if (this.layoutConf.sidebarStyle === 'compact') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full',
        sidebarCompactToggle: false
      }, { transitionClass: true });
    }

    // * --> compact
    this.layout.publishLayoutChange({
      sidebarStyle: 'compact',
      sidebarCompactToggle: true
    }, { transitionClass: true });

  }

  onSearch(e: any) {
    //   console.log(e)
  }

  // SignOut from the application
  public logout(): void {
    this._authService.logout().subscribe()
  }
}
